import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';
import { FormattedMessage } from 'react-intl';
import { FastField } from 'formik';
import { Grid, Label } from '../../common/components';
import messages from '../messages';
import YearField from './YearField';
import IssueNumberField from './IssueNumberField';

const NumberField = ({ className, field, form }) => {
  const error = useMemo(() => (
    !!(get(`${field.name}.year`, form.errors) && get(`${field.name}.year`, form.touched))
    || (get(`${field.name}.issueNumber`, form.errors) && get(`${field.name}.issueNumber`, form.touched))
  ), [field.name, form.errors, form.touched]);

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
      className={className}
    >
      <Grid item xs={1}>
        <Label
          htmlFor={field.name}
          error={error}
        >
          <FormattedMessage {...messages.numberFieldLabel} />
        </Label>
      </Grid>
      <Grid container item xs={6} alignItems="center">
        <FormattedMessage {...messages.numberFieldNumberSuffix} />
        <FastField
          name={`${field.name}.year`}
          component={YearField}
        />
        -
        <FastField
          name={`${field.name}.issueNumber`}
          component={IssueNumberField}
          id={field.name}
        />
        <FormattedMessage {...messages.numberFieldOrdinal} />
      </Grid>
    </Grid>
  );
};

NumberField.propTypes = {
  className: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.shape({}),
    ]).isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({
      number: PropTypes.shape({
        year: PropTypes.number,
        issueNumber: PropTypes.string,
      }),
    }).isRequired,
    touched: PropTypes.shape({
      number: PropTypes.shape({
        year: PropTypes.bool,
        issueNumber: PropTypes.bool,
      }),
    }).isRequired,
  }).isRequired,
};

NumberField.defaultProps = {
  className: undefined,
};

export default NumberField;
